import Modifier from 'src/models/modifier-set/Modifier'
// Modifier Sets have modifiers as a reference. Therefore the modifier collection is missing functionality
// expected by the model table.
// This is a temporary class to provide the missing functionality.
export default class ModifierCollection extends Modifier {
  static name = 'ModifierCollection'

  // Ignore displayOrder sorting to respect the order passed to the constructor
  static ignoreDisplayOrder = true

  constructor (data, parent, options = {}) {
    super(data, {
      ...options,
      isCollection: true,
      parent
    })
  }

  get humanCollectionName () {
    return 'Modifiers'
  }

  get humanTypeName () {
    return 'Modifier'
  }

  get modelTypeName () {
    return 'Modifier'
  }

  remove (model) {
    // not calling super.remove(model) because we don't want to destroy the model
    this.setData(_.filter(this.data, (item) => item.id !== model.id))

    if (_.isEmpty(this.parent?.modifierIds)) return

    // Update parent ModifierSet's modifierIds to trigger reactivity
    const currentModifierIds = this.parent.modifierIds || []

    const updatedModifierIds = _.without(currentModifierIds, model.id)

    this.parent.modifierIds = updatedModifierIds
  }
}
